import { JobPlanejamentoStatus } from '../generated/backend-enums.js';
export { JobPlanejamentoStatus };
export const JobPlanejamentoStatusMap = {
    PENDENTE: 'Pendente',
    [JobPlanejamentoStatus.EM_EXECUCAO]: 'Em Execução',
    [JobPlanejamentoStatus.COM_CRIACAO]: 'Com Criação',
    [JobPlanejamentoStatus.CONCLUIDO]: 'Concluído',
    [JobPlanejamentoStatus.NAO_APLICAVEL]: 'Não Aplicável',
    [JobPlanejamentoStatus.STAND_BY]: 'Stand By',
    [JobPlanejamentoStatus.AGUARDANDO_BRIEF_CLIENTE]: 'Aguardando Briefing Cliente',
    [JobPlanejamentoStatus.AGUARDANDO_ESTUDO_VERBA]: 'Aguardando Estudo de Verba',
    [JobPlanejamentoStatus.AGUARDANDO_PASSAGEM_INTERNA]: 'Aguardando Passagem Interna',
};
